import { render, staticRenderFns } from "./socialProfiles.vue?vue&type=template&id=2c227680&scoped=true&lang=html&"
import script from "./socialProfiles.vue?vue&type=script&lang=js&"
export * from "./socialProfiles.vue?vue&type=script&lang=js&"
import style0 from "./socialProfiles.vue?vue&type=style&index=0&id=2c227680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c227680",
  null
  
)

export default component.exports